import { FC, Fragment, useState } from "react";
import { MatchedRequirementColumn } from "../../pages/Create";
import { OrderAddV2, OrderV2 } from "@/types/inventoryV2";
import { Button, Flex, notification, Result, Tag } from "antd";
import { useTranslation } from "react-i18next";
import CommonTable from "@/components/CommonTable";
import SText from "@/styles/SText";
import { ColumnType } from "antd/es/table";
import { numFormmater } from "../../util";
import { orderAdd, orderPreOut } from "@/apis/inventoryv2";

interface ReTryPreOutProps {
  failItems: MatchedRequirementColumn[];
  failAdd: OrderAddV2;
  number: string;
  scrollHeight: number;
  locTypes: number[];
  preOutLocationTypes: number[];
  onOk: () => void;
};

const ReTryPreOut: FC<ReTryPreOutProps> = ({ failItems, failAdd, number, scrollHeight, locTypes, preOutLocationTypes, onOk }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const columns: ColumnType<MatchedRequirementColumn>[] = [
    {
      key: "sequence",
      title: <SText text={t("purchase.seq")} />,
      width: 80,
      fixed: "left",
      render: (_, record, index) => index + 1
    },
    {
      key: "productCode",
      title: <SText text={t("product.code")} />,
      dataIndex: "code",
      width: 160,
      fixed: "left",
      render(value, row, rowIndex) {
        return <SText text={row?.product?.code || ""} style={{ color: row.allocated > row.useNum ? "red" : "unset" }} />;
      }
    },
    {
      key: "productName",
      title: <SText text={t("product.name")} />,
      dataIndex: "name",
      width: 140,
      fixed: "left",
      render(value, row, rowIndex) {
        return <SText text={row?.product?.name || ""} />;
      }
    },
    {
      key: "model",
      title: <SText text={t("order.brand")} />,
      width: 340,
      fixed: "left",
      render(value, row, rowIndex) {
        return <SText text={row?.product?.model || ""} />;
      }
    },
    {
      key: "uom",
      title: <SText text={t("product.uom")} />,
      width: 160,
      fixed: "left",
      render(value, row, rowIndex) {
        return <SText text={row?.product?.uom || ""} />;
      }
    },
    {
      key: "preOutNum",
      title: <SText text={t("bom.preOutNum")} />,
      dataIndex: "preOutNum",
      width: 160,
      fixed: "right",
      render: (value, row, rowIndex) => <SText text={numFormmater(row.preOutNum)} />
    }
  ];

  const handleReTry = async () => {
    setLoading(true);
    let orderRes: OrderV2 | null = null;
    try {
      orderRes = await orderAdd(failAdd);
      await orderPreOut(orderRes?.id ?? '', locTypes.length > 0 ? locTypes : preOutLocationTypes);
      onOk();
    } catch (err: any) {
      if (err?.code === 73010) {
        notification.error({
          message: t('inventory.proQtyFalse'),
          description: err?.extra?.map((i: { productId: string }) => i.productId)?.join(', ')
        })
      } else if ([73022, 73014].includes(err)) {
        notification.error({
          message: t('inventory.calcErr')
        })
      } else if ([73024, 73028].includes(err?.code)) {
        notification.error({
          message: t('warehouse.insufficientInventory'),
          description: err?.extra?.productCode
        })
      }
      else notification.error({ placement: 'top', message: t('requirement.createPreOutInventoryFail'), description: t('requirement.doneSuccess') })
    } finally { setLoading(false) };
  }
  return (
    <Fragment>
      <Result status="warning"
        title={t("requirement.doneSuccess")}
        subTitle={t('requirement.preOutErrTip', { number })}
        style={{ padding: '10px 32px' }}
      />
      <Flex gap={6} style={{ marginBottom: 8 }}>
        <Button type="primary" loading={loading} onClick={handleReTry}>{t('requirement.rePreOutAdd')}</Button>
      </Flex>
      <CommonTable
        rowKey={row => row.matchKey}
        columns={columns}
        dataSource={failItems}
        scrollHeight={scrollHeight - 160}
      />
    </Fragment>
  )
};

export default ReTryPreOut;